import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import type { Partner } from '../../../../components/LeadFormIndex/types';
import { useQuery } from '../../../../utils/helpers';
import shouldShowPlrHero from '../heroVariant';
import PlrShell from '../landing/PlrShell';
import { PlrLead, PlrTitle } from '../landing/ui';
import { plr } from '../landing/tokens';
import {
  COMPLEMENT_DISCLOSURE,
  INVITE_DEAD_BODY,
  INVITE_DEAD_TITLE,
  INVITE_RATE_LIMIT_BODY,
  INVITE_RATE_LIMIT_TITLE,
} from './copy';

// Invitación al complemento que no se puede usar (enlace vencido o la solicitud ya no admite
// complemento) o demasiadas consultas: mismos textos que la bienvenida anterior, en el shell.
export default function InviteUnavailable({ partner, rateLimited }: {
  partner: Partner,
  rateLimited: boolean,
}) {
  const query = useQuery();
  const showHero = shouldShowPlrHero({
    backgroundImage: partner.config.styles?.backgroundImage,
    hideHero: partner.config.preLoanRequestConfig?.hideHero,
    heroQuery: query.get('hero'),
    partnerName: partner.partnerName,
  });
  return (
    <PlrShell partner={partner} showHero={showHero} testId="complement-invite-unavailable">
      <PlrTitle size="result" testId="complement-invite-header">
        {rateLimited ? INVITE_RATE_LIMIT_TITLE : INVITE_DEAD_TITLE}
      </PlrTitle>
      <PlrLead testId="complement-invite-text">
        {rateLimited ? INVITE_RATE_LIMIT_BODY : INVITE_DEAD_BODY}
      </PlrLead>
      <Box
        component="p"
        sx={{
          m: 0, fontSize: { xs: 12.5, sm: 13 }, lineHeight: 1.45, color: plr.muted,
        }}
      >
        {COMPLEMENT_DISCLOSURE}
      </Box>
    </PlrShell>
  );
}

export function InviteLoading() {
  return (
    <Box sx={{
      display: 'grid', placeItems: 'center', minHeight: '100vh', color: plr.ink,
    }}
    >
      <CircularProgress color="inherit" size={32} />
    </Box>
  );
}
